import { render, staticRenderFns } from "./TeamFormation.vue?vue&type=template&id=59dbfda2&scoped=true&"
import script from "./TeamFormation.vue?vue&type=script&lang=js&"
export * from "./TeamFormation.vue?vue&type=script&lang=js&"
import style0 from "./TeamFormation.vue?vue&type=style&index=0&id=59dbfda2&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dbfda2",
  null
  
)

export default component.exports